import { render, staticRenderFns } from "./addCustom.vue?vue&type=template&id=70be08b2&scoped=true"
import script from "./addCustom.vue?vue&type=script&lang=js"
export * from "./addCustom.vue?vue&type=script&lang=js"
import style0 from "./addCustom.vue?vue&type=style&index=0&id=70be08b2&prod&scoped=true&lang=css"
import style1 from "./addCustom.vue?vue&type=style&index=1&id=70be08b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be08b2",
  null
  
)

export default component.exports